module.exports = __webpack_public_path__ + "static/media/BM_New_04.b.2.5973d136.jpg";